const MEDIA_QUERIES = {
	MOBILE: '(max-width: 768px)',
}

export { MEDIA_QUERIES }
